import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import i1 from "./assets/images/1.png";
import discordpng from "./assets/images/discord.png";
import twitterpng from "./assets/images/twitter.png";
import openseapng from "./assets/images/opensea.png";
import instagrampng from "./assets/images/instagram.png";
import tiktokpng from "./assets/images/tiktok.png";
import background from "./assets/images/background.png";
import vandalCorp from "./assets/images/vclogo.png";
import { QuantityPicker } from 'react-qty-picker';
import config from "./configData.json";

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [feedback, setFeedback] = useState("Own a Marion!");
  const [claimingNft, setClaimingNft] = useState(false);
  const [mintAmount, setMintAmount] = useState(1);
  const mintActive = false;

  const claimNFTs = () => {
    debugger;
    if(data.maxSupply == 0)
    {
      setFeedback("Contract not loaded, please refresh your browser or try again later...");
      return; // Dont allow user to try and mint while smart contract is not initialised.
    }
    if (mintAmount <= 0 && mintAmount > data.maxMintAmount) {
      return;
    }
    var mintPrice = 10;
    if(data.mvpCount > 0) {
      var discount =  config.MVPDISCOUNT / 100
      var discountAmount = mintPrice * discount
      mintPrice = mintPrice - discountAmount;
    }
    var gasLimit = config.GAS_LIMIT * mintAmount
    setFeedback("Minting your Marion NFT...");
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(mintAmount)
      .send({
        gasLimit: gasLimit,
        to: config.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: blockchain.web3.utils.toWei((mintAmount * mintPrice).toString(), "ether"),
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Transaction Signing rejected or an error occured, please try again");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "WOW, you are part of the Marions! View your Token(s) on Opensea."
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (
    <s.Screen style={{  }} image= {background}>
      <s.Container flex={1} ai={"center"} style={{ padding: 24 }}>
        <s.TextTitle 
          style={{ textAlign: "center", fontSize: 56, fontWeight: "bold" }}
        >
          Come join the Vandals!
        </s.TextTitle>
        <s.TextTitle 
          style={{ textAlign: "center", fontSize: 44, fontWeight: "bold" }}
        >
          Marion Minting Date: April 11th 2022
        </s.TextTitle>
        
        <s.SpacerMedium  />
        <s.ResponsiveWrapper flex={1} style={{ padding: 24 }}>
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <s.StyledImg alt={"example"} src={i1} />
            <s.SpacerMedium />
            <s.TextDescription
              style={{ textAlign: "center", fontSize: 30, fontWeight: "bold" }}
            >
              {blockchain.account == null ? 
                ( 
                  <>
                    {mintActive ? "Connect Wallet to show mint Progress!" : ""} 
                  </>
                ):
                ( 
                  <>
                    {data.totalSupply + " / "  + data.maxSupply} minted
                  </>
                )}
            </s.TextDescription>
            <s.TextTitle
              style={{ textAlign: "center", fontSize: 25, fontWeight: "italic" ,padding: 24}}
            >
               {blockchain.account == null ? 
                ( 
                  <></>
                ):
                ( 
                  <>
                    You have {data.ownedNFTCount} Marion NFT's!
                  </>
                )}
              </s.TextTitle>
              <s.TextTitle
              style={{ textAlign: "center", fontSize: 28, fontWeight: "bold" ,padding: 24, color: "gold"}}
            >
               {blockchain.account != null && data.mvpCount > 0 ?
               (
                 <>
                  Eligible for MVP Discount! ({data.mvpCount} AAA's)
                  </>
               ):
               (
                <>  
                Be sure to pick up a AAA pass now before minting Marion to mint at a HUGE 50% discount!
                <s.SpacerMedium/>
                <s.StyledLinkImg alt={"example"} src={openseapng} onClick={(e) => {
              e.preventDefault();
              const url = config.OPENSEAURL;
              window.open(url, '_blank');}}/>
                </>
                
               )
               }
               
              </s.TextTitle>
          </s.Container>
          <s.SpacerMedium />
          <s.MintContainer
            flex={1}
            jc={"center"}
            ai={"center"}
            style={{ padding: 20}}
          >
            {Number(data.totalSupply) == config.SUPPLY_LIMIT || !mintActive ? (
              <>
                <s.TextTitle style={{ textAlign: "center", fontSize:32}}>
                  {mintActive ? "The sale has ended." : <><s.StyledImgLogo alt={"example"} src={vandalCorp} /></>}
                </s.TextTitle>
                <s.TextDescription style={{ textAlign: "center", fontSize : 44 }}>  
                  {mintActive ? "You can still find Marion NFTs on Opensea" : ""}
                </s.TextDescription>
                <s.TextDescription style={{ textAlign: "center", fontSize : 32, color: "gold"}}>  
                  {mintActive ? "" : "+ Marion Mint Party - 19:00 BST "}
                </s.TextDescription>
                <s.TextDescription style={{ textAlign: "center", fontSize : 32 , color: "gold"}}>  
                  {mintActive ? "" : "+ Marion Mint goes live - 19:30 BST"}
                </s.TextDescription>

                <s.ImgLinkContainer jc={"center"} ai={"center"}>
               <s.StyledLinkImg alt={"example"} src={discordpng} onClick={(e) => {
                                e.preventDefault();
                                const url = config.DISCORDURL;
                                window.open(url, '_blank');}}/>
                </s.ImgLinkContainer>
                <s.SpacerXLarge/>
                <s.SpacerSmall/>
              </>
            ) : (
              <>
                <s.TextTitle style={{ textAlign: "center", fontSize : 28 }}>
                  <>
                    {blockchain.account == null ? "" : "Mint Price: 10 MATIC (AAA HOLDERS: 5 MATIC)**" }
                  </>
                </s.TextTitle>
                <s.SpacerXSmall />
                <s.TextDescription style={{ textAlign: "center" }}>
                {blockchain.account == null ? "" : "** Excluding gas fee"}
                </s.TextDescription>
                <s.SpacerSmall />
                <s.TextDescription style={{ textAlign: "center", fontSize : 25}}>
                {blockchain.account == null ? "" : feedback}
                </s.TextDescription>
                <s.SpacerMedium />
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>
                    <s.TextDescription style={{ textAlign: "center" , fontSize:30}}>
                      Connect to the Polygon network
                    </s.TextDescription>
                    <s.SpacerSmall />
                    <s.StyledButton
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                      }}
                    >
                      CONNECT
                    </s.StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription style={{ textAlign: "center" }}>
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <s.Container ai={"center"} jc={"center"} fd={"row"}>
                    <s.StyledButton
                      disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        claimNFTs();
                        getData();
  
                      }}
                    >
                      {claimingNft ? "BUSY" : "MINT"}
                      
                    </s.StyledButton>
                  </s.Container>
                )}
              </>
            )}
            {blockchain.smartContract != null ? (
            <s.Container jc= {"center"} ai={"center"} style = {{padding: 25}}>
            <QuantityPicker value = {mintAmount} onChange={function (newValue) {setMintAmount(newValue); }} min={1} max={data.maxMintAmount} />
              <s.TextTitle style ={{fontSize:15}}>
              Max Mint:{blockchain.account == null ? "" : data.maxMintAmount} 
              </s.TextTitle>
              
            </s.Container>
            ) :("")}
          </s.MintContainer>
        </s.ResponsiveWrapper>
        <s.SpacerSmall />
        <s.TextDescription style={{ textAlign: "center", fontSize: 18 }}>
            All our links:
          </s.TextDescription>
        <s.ImgLinkContainer jc={"center"} ai={"center"}>
            <s.StyledLinkImg alt={"example"} src={discordpng} onClick={(e) => {
              e.preventDefault();
              const url = config.DISCORDURL;
              window.open(url, '_blank');}}/>
            <s.StyledLinkImg alt={"example"} src={twitterpng} onClick={(e) => {
              e.preventDefault();
              const url = config.TWITTERURL;
              window.open(url, '_blank');}}/>
            <s.StyledLinkImg alt={"example"} src={openseapng} onClick={(e) => {
              e.preventDefault();
              const url = config.OPENSEAURL;
              window.open(url, '_blank');}}/>
            <s.StyledLinkImg alt={"example"} src={instagrampng} onClick={(e) => {
              e.preventDefault();
              const url = config.INSTAGRAMURL;
              window.open(url, '_blank');}}/>
            <s.StyledLinkImg alt={"example"} src={tiktokpng} onClick={(e) => {
              e.preventDefault();
              const url = config.TIKTOKURL;
              window.open(url, '_blank');}}/>
          </s.ImgLinkContainer>
          <s.SpacerSmall />
        <s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>
          <s.TextDescription style={{ textAlign: "center", fontSize: 14 }}>
            Please make sure you are connected to the right network (Polygon
            Mainnet) and the correct address. Please note: Once you make the
            purchase, you cannot undo this action.
          </s.TextDescription>
          <s.SpacerSmall />
          <s.TextDescription style={{ textAlign: "center", fontSize:14}}>
            We have set the gas limit to {config.GAS_LIMIT} per NFT for the contract to successfully
            mint your NFT. We recommend that you don't change the gas limit.
          </s.TextDescription>
          <s.SpacerLarge/>

          <s.SpacerSmall/>

        </s.Container>
      </s.Container>
    </s.Screen>
  );
}

export default App;
